export const FIRST_PAGE = 'FIRST_PAGE';
export const LOAD_MORE = 'LOAD_MORE';